module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvaG9yaXpvbnRhbC1zbWFydHBob25lLjRmZGVkYjg1LnBuZyI7"